import React from "react";
import { Box, Container, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import {postAnalytics} from "../../../utils/post_analytics"
const CallToAction = () => {
  const navigate = useNavigate();

  const handleNavigate = () => {
    postAnalytics("landing-page", ["go-to-register"]);
    navigate("/register")
  } 

  return (
    <Box
      id="contact"
      component="section"
      sx={{
        py: { xs: 12, md: 12, lg: 16 },
      }}
    >
      <Container>
        <Box
          sx={{
            textAlign: "center",
            maxWidth: 600,
            mx: "auto",
          }}
        >
          <Typography
            variant="h2"
            component="h2"
            color="text.primary"
            gutterBottom
          >
            Ready to Elevate Your Fitness?
          </Typography>
          <Typography
            variant="body1"
            color="text.secondary"
            sx={{ mb: 4, fontSize: { md: "1.25rem" } }}
          >
            Our goal is to create the best gym workout tracking app on the market. Join us in our mission.
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              justifyContent: "center",
              gap: 2,
              maxWidth: 400,
              mx: "auto",
            }}
          >
            <Button
              onClick={handleNavigate}
              variant="contained"
              color="primary"
              size="large"
              fullWidth
            >
              Join
            </Button>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default CallToAction;
